// extracted by mini-css-extract-plugin
export default {"patientInformationsButtonsContainer":"PatientInformationsActionButtons_patientInformationsButtonsContainer__o-J4g"};